<script setup lang="ts">
import type { Slots } from './types';
import TopRows from '../rows/rows.vue';

defineSlots<Slots>();
</script>

<template>
	<div class="top-islandRows">
		<div
			v-if="$slots.title"
			class="top-islandRows_title"
		>
			<slot name="title"></slot>
		</div>

		<TopRows gap="l" class="top-islandRows_rows">
			<slot></slot>
		</TopRows>
	</div>
</template>

<style>
.top-islandRows {
	display: flex;
	flex-direction: column;
	gap: var(--top-gap-2);
}

.top-islandRows_title {
	font-size: 20px;
	font-weight: bold;
}

.top-islandRows_rows {
	border-radius: var(--top-radius-4);
	background: var(--color-bg-shading-2);
	padding: var(--top-padding-3);
}

/* В islandRows у всех полей ввода внутри top-rows прозрачные рамки */
.top-islandRows_rows .top-rows > .top-input,
.top-islandRows_rows .top-rows > .top-textarea,
.top-islandRows_rows .top-rows > .top-select { --top-forms-border-color: transparent }

/* Размеры форм */
.top-islandRows_rows .top-button,
.top-islandRows_rows .top-input,
.top-islandRows_rows .top-textarea,
.top-islandRows_rows .top-select { width: auto; flex-grow: 1; display: flex; }

.top-islandRows_rows .top-forms-optionWrapper:not(.top-optionGroup_item) { padding: 0; flex-grow: 1; }
</style>
